var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-text',[_c('div',{staticClass:"d-flex align-center justify-center",staticStyle:{"min-height":"500px"}},[_c('span',{staticClass:"text-subtitle-1"},[_vm._v(" Vui lòng nâng cấp tài khoản để được cấp quyền xem ")])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }